<div class="hero kareli">
  <div class="sar">
    <p class="etiket">Kazanım temelli öğrenme · LGS ve YKS</p>
    <h1 class="h1" style="margin-top:18px">Bilgiyi taze tut: <span class="vurgu">unutmadan bir gün önce</span> hatırlat.</h1>
    <p class="giris-p">pratiu her öğrencinin unutma eğrisini ayrı takip eder. Hangi soruyu kime hangi gün soracağını sen düşünme — biz zamanlarız, sen öğret.</p>
    <div class="hero-btn">
      <a class="btn kirmizi" [href]="appUrl" target="_blank" rel="noopener">Hemen kayıt olun <svg><use xlink:href="#i-ok"></use></svg></a>
      <a class="btn ikincil" routerLink="/teachers">Öğretmenler için</a>
    </div>
    <div class="hero-kanit">
      <div><span class="sayi">10.000</span><span class="etiket">soru</span></div>
      <div><span class="sayi">özgün</span><span class="etiket">LGS &amp; YKS soruları</span></div>
      <div><span class="sayi">6</span><span class="etiket">tekrar basamağı</span></div>
      <div><span class="sayi">yüzlerce</span><span class="etiket">öğretmen</span></div>
    </div>

    <div class="egri-kutu">
      <div class="egri-ust">
        <p class="etiket">Tek bir kazanımın 35 günü</p>
        <div class="anah">
          <span><i style="background:var(--kirmizi)"></i> tekrar olmadan</span>
          <span><i style="background:var(--mor)"></i> pratiu ile</span>
          <span><i style="background:#F2C230"></i> tekrar anı</span>
        </div>
      </div>
      <svg class="egri" viewBox="0 0 1100 250" role="img" aria-label="Tekrar yapılmadığında hatırlama 35 günde yüzde 21'e düşer; pratiu'nun planladığı dört tekrarla yüzde 92 seviyesinde kalır.">
        <g stroke="var(--kare)" stroke-width="1"><path d="M60 38H1060M60 92H1060M60 146H1060M60 200H1060"/></g>
        <g font-family="Azeret Mono" font-size="10" fill="var(--kursun)">
          <text x="18" y="42">%100</text><text x="24" y="204">%20</text>
          <text x="54" y="228">1. gün</text><text x="330" y="228">7</text><text x="598" y="228">16</text><text x="878" y="228">28</text><text x="1028" y="228">35</text>
        </g>
        <path class="iz" d="M60 38C130 114 200 166 320 186C460 208 700 214 1060 216" fill="none" stroke="var(--kirmizi)" stroke-width="2" stroke-dasharray="6 5"/>
        <path class="iz" d="M60 38C92 70 108 88 132 92C160 96 168 64 196 60C240 92 258 114 300 118C352 122 356 72 400 64C470 104 490 126 560 128C650 128 648 60 700 52C800 92 830 108 900 108C1000 108 1000 46 1060 42" fill="none" stroke="var(--mor)" stroke-width="2.4" stroke-linejoin="round"/>
        <g>
          <circle class="nk" cx="132" cy="92" r="5" fill="#F2C230" stroke="var(--gece)" stroke-width="2" style="animation-delay:.85s"/>
          <circle class="nk" cx="300" cy="118" r="5" fill="#F2C230" stroke="var(--gece)" stroke-width="2" style="animation-delay:1.2s"/>
          <circle class="nk" cx="560" cy="128" r="5" fill="#F2C230" stroke="var(--gece)" stroke-width="2" style="animation-delay:1.6s"/>
          <circle class="nk" cx="900" cy="108" r="5" fill="#F2C230" stroke="var(--gece)" stroke-width="2" style="animation-delay:2s"/>
        </g>
        <g class="nk" style="animation-delay:2.3s" font-family="Hanken Grotesk" font-size="12.5" font-weight="600">
          <text x="1000" y="28" fill="var(--mor)" text-anchor="end">%92 hatırlama</text>
          <text x="1000" y="240" fill="var(--kirmizi)" text-anchor="end">%21 hatırlama</text>
        </g>
      </svg>
    </div>
    <div style="height:70px"></div>
  </div>
</div>

<div class="sinav" id="sinav">
  <div class="sar bol">
    <p class="etiket">Hazır soru havuzu</p>
    <h2 class="h2" style="margin:14px 0 16px;max-width:20ch">Aynı soruyu ezberlemesin. Özgün kardeşini çözsün.</h2>
    <p class="giris-p">LGS ve YKS kazanımlarına göre yazılmış özgün soruları etiketledik. Yapay zekâ her bir soruyu aynı kazanımda beş farklı tipe dönüştürüyor: sayısı değişmiş, bağlamı değişmiş, çeldiricisi sertleşmiş hâllerine. Öğrenci ezberlediği soruyu değil, o kazanımı çözmüş oluyor.</p>

    <div class="sinav-sek">
      <button type="button" [class.on]="aktifS === 'lgs'" (click)="secSinav('lgs')">LGS · 8. sınıf</button>
      <button type="button" [class.on]="aktifS === 'tyt'" (click)="secSinav('tyt')">YKS · TYT</button>
      <button type="button" [class.on]="aktifS === 'ayt'" (click)="secSinav('ayt')">YKS · AYT</button>
    </div>

    <div class="sinav-govde">
      <div class="havuz">
        <h3 class="h3">{{ havuz.bas }}</h3>
        <div style="margin-top:16px">
          <div class="havuz-sat" *ngFor="let sat of havuz.havuz">
            <span>{{ sat[0] }}</span><span class="sayi">{{ sat[1] }}</span>
          </div>
        </div>
        <p class="havuz-not">{{ havuz.not }}</p>
      </div>

      <div class="don">
        <div class="don-ust">
          <p class="etiket">Soru dönüştürücü</p>
          <span class="rozet" style="background:rgba(232,64,47,.16);border-color:rgba(232,64,47,.4);color:#FF9182">yapay zekâ</span>
        </div>
        <div class="don-kok">
          <span class="kaynak">{{ havuz.kaynak }}</span>
          <p>{{ havuz.kok }}</p>
        </div>
        <div class="don-sec">
          <button type="button" [class.on]="aktifT === 0" (click)="secTur(0)">Sayı değişimi</button>
          <button type="button" [class.on]="aktifT === 1" (click)="secTur(1)">Bağlam değişimi</button>
          <button type="button" [class.on]="aktifT === 2" (click)="secTur(2)">Çeldirici sertleştirme</button>
          <button type="button" [class.on]="aktifT === 3" (click)="secTur(3)">Ters kurgu</button>
          <button type="button" [class.on]="aktifT === 4" (click)="secTur(4)">Kazanım birleştirme</button>
        </div>
        <div class="don-cikti">
          <div class="el">
            <span class="nasil"><svg style="width:12px;height:12px"><use xlink:href="#i-kv"></use></svg> {{ tur.n }}</span>
            <p class="govde">{{ tur.g }}</p>
            <div class="secenek">
              <div *ngFor="let sec of tur.s" [class.dogru]="sec.dogru"><b>{{ sec.harf }}</b><span>{{ sec.metin }}</span></div>
            </div>
          </div>
        </div>
        <div class="don-alt">
          <span class="rozet" *ngFor="let r of tur.r">{{ r }}</span>
          <span style="margin-left:auto">
            <a class="btn k" [href]="appUrl" target="_blank" rel="noopener" style="background:rgba(255,255,255,.1);border-color:rgba(255,255,255,.2);color:#fff">Öğretmen onayına gönder</a>
          </span>
        </div>
      </div>
    </div>

    <div class="g3" style="margin-top:34px">
      <div class="ozet" style="background:rgba(255,255,255,.04);border-color:rgba(255,255,255,.14)">
        <div class="rk" style="border-color:rgba(255,255,255,.2);color:#FF9182"><svg><use xlink:href="#i-dongu"></use></svg></div>
        <h4 class="h4" style="color:#fff">Bir soru, beş tekrar</h4>
        <p style="color:#A9AEC6">Aynı kazanım 1·3·7·16·35·90 gün basamaklarında farklı bir türevle geri gelir. Öğrenci cevabı değil, yöntemi hatırlar.</p>
      </div>
      <div class="ozet" style="background:rgba(255,255,255,.04);border-color:rgba(255,255,255,.14)">
        <div class="rk" style="border-color:rgba(255,255,255,.2);color:#FF9182"><svg><use xlink:href="#i-hedef"></use></svg></div>
        <h4 class="h4" style="color:#fff">Çeldirici, gerçek hatadan üretilir</h4>
        <p style="color:#A9AEC6">Yanlış şıklar rastgele değil: o kazanımda öğrencilerin en sık yaptığı işlem hatalarından türetilir.</p>
      </div>
      <div class="ozet" style="background:rgba(255,255,255,.04);border-color:rgba(255,255,255,.14)">
        <div class="rk" style="border-color:rgba(255,255,255,.2);color:#FF9182"><svg><use xlink:href="#i-tik"></use></svg></div>
        <h4 class="h4" style="color:#fff">Öğretmen onayından geçer</h4>
        <p style="color:#A9AEC6">Üretilen her soru taslak olarak gelir. Sen onaylamadan hiçbir öğrencinin karşısına çıkmaz.</p>
      </div>
    </div>

    <div style="display:flex;gap:11px;margin-top:32px;flex-wrap:wrap">
      <a class="btn kirmizi" [href]="appUrl" target="_blank" rel="noopener">Soru bankasını gör <svg><use xlink:href="#i-ok"></use></svg></a>
      <a class="btn hayalet" [href]="appUrl" target="_blank" rel="noopener">Ücretsiz dene</a>
    </div>
  </div>
</div>

<div class="sar bol">
  <div class="bol-bas">
    <span class="etiket">Kimler için</span>
    <h2 class="h2">Dört farklı ekran, tek bir kazanım verisi.</h2>
  </div>
  <div class="g4">
    <a class="ozet" routerLink="/education-institutions">
      <div class="rk"><svg><use xlink:href="#i-bina"></use></svg></div>
      <h4 class="h4">Eğitim kurumları</h4>
      <p>Şube şube değil, kazanım kazanım rapor. Müfredat güncellemesini veriyle savun.</p>
      <span class="bag">Daha fazla <svg><use xlink:href="#i-ok"></use></svg></span>
    </a>
    <a class="ozet" routerLink="/corporates">
      <div class="rk"><svg><use xlink:href="#i-canta"></use></svg></div>
      <h4 class="h4">Kurumsal firmalar</h4>
      <p>Zorunlu eğitimden altı ay sonra ne kaldığını ölçün. Tazeleme tekrarını otomatik planlayın.</p>
      <span class="bag">Daha fazla <svg><use xlink:href="#i-ok"></use></svg></span>
    </a>
    <a class="ozet" routerLink="/teachers">
      <div class="rk"><svg><use xlink:href="#i-ders"></use></svg></div>
      <h4 class="h4">Öğretmenler</h4>
      <p>Sınıf kur, soru seç, ata. Tekrar planı kendi kendine döner; sen zayıf kazanıma bakarsın.</p>
      <span class="bag">Daha fazla <svg><use xlink:href="#i-ok"></use></svg></span>
    </a>
    <a class="ozet" routerLink="/students">
      <div class="rk"><svg><use xlink:href="#i-ogr"></use></svg></div>
      <h4 class="h4">Öğrenci / veli</h4>
      <p>Günde tek bir liste. Bitince biter. Veli, sıralama değil gelişim görür.</p>
      <span class="bag">Daha fazla <svg><use xlink:href="#i-ok"></use></svg></span>
    </a>
  </div>
</div>

<div style="border-top:1px solid var(--cizgi);background:var(--kagit-2)">
  <div class="sar bol">
    <div class="g2" style="gap:44px;align-items:start">
      <div>
        <span class="etiket">Biz ne yaparız</span>
        <h2 class="h2" style="margin:14px 0 18px">Sınav çözdürmüyoruz. Unutmayı geciktiriyoruz.</h2>
        <p style="color:#3D4257;margin-bottom:14px">Bir konuyu öğrenmek ile o konuyu altı ay sonra hatırlamak iki ayrı iştir. Okullar birincisini iyi yapar; ikincisi genellikle öğrencinin şansına kalır.</p>
        <p style="color:#3D4257">pratiu ikinci işi üstlenir. Her öğrencinin her kazanımda ne kadar hatırladığını takip eder, unutma eşiğine yaklaştığı gün o kazanımdan yeni bir soru gönderir. Öğretmene düşen tek şey, hangi kazanımın sınıfça çürüdüğüne bakıp dersini ona göre kurmaktır.</p>
      </div>
      <div class="kart">
        <div class="kart-bas"><h3 class="h3">Tekrar şeridi</h3><span class="rozet mo">6 basamak</span></div>
        <div style="padding:6px 18px 18px">
          <div class="serit">
            <div class="durak bugun"><div class="sut" style="height:96px;animation-delay:.05s"><span class="n">612</span></div><div class="cz"></div><span class="lbl">1g</span></div>
            <div class="durak"><div class="sut" style="height:72px;animation-delay:.12s"><span class="n">459</span></div><div class="cz"></div><span class="lbl">3g</span></div>
            <div class="durak"><div class="sut" style="height:116px;animation-delay:.19s"><span class="n">741</span></div><div class="cz"></div><span class="lbl">7g</span></div>
            <div class="durak"><div class="sut" style="height:138px;animation-delay:.26s"><span class="n">886</span></div><div class="cz"></div><span class="lbl">16g</span></div>
            <div class="durak"><div class="sut" style="height:108px;animation-delay:.33s"><span class="n">694</span></div><div class="cz"></div><span class="lbl">35g</span></div>
            <div class="durak"><div class="sut" style="height:146px;animation-delay:.4s;background:var(--yesil)"><span class="n">926</span></div><div class="cz"></div><span class="lbl">90g</span></div>
          </div>
          <p class="soluk" style="font-size:13px;margin-top:16px;padding-top:14px;border-top:1px solid var(--kagit-3)">
            Sağa gittikçe soru yerleşmiş demektir. Kırmızı sütun bugün sorulacakları, yeşil sütun kalıcı hâle gelenleri gösterir.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="cta">
  <div class="cta-ic">
    <div>
      <h2 class="h2">Sınıfını bu hafta kur.</h2>
      <p>Okul e-postanla giriş yap, sınıfını içe aktar, ilk sınavını 10 dakikada ata.</p>
    </div>
    <a class="btn kirmizi" [href]="appUrl" target="_blank" rel="noopener">Hemen kayıt olun <svg><use xlink:href="#i-ok"></use></svg></a>
  </div>
</div>
